import { v4 as uuidv4 } from 'uuid';

// SessionHelper.ts

export default class SessionHelper {
  private static sessionKey = 'sessionId';
  private static sessionId: string | null = null;

  // Method to get the sessionId, first from memory then from sessionStorage
  public static getSessionId(): string | null {
    if (this.sessionId) {
      return this.sessionId;
    }
    
    try {
      const storedId = sessionStorage.getItem(this.sessionKey);
      if (storedId) {
        this.sessionId = storedId;
        return storedId;
      }
    } catch (error) {
      console.warn('Failed to access sessionStorage:', error);
    }
    
    return null;
  }

  // Method to set the sessionId in memory and sessionStorage
  public static setSessionId(sessionId: string): void {
    this.sessionId = sessionId;
    
    try {
      sessionStorage.setItem(this.sessionKey, sessionId);
    } catch (error) {
      console.warn('Failed to save to sessionStorage:', error);
    }
  }

  // Method to generate a new sessionId and store it
  public static generateSessionId(): string {
    const sessionId = uuidv4();
    this.setSessionId(sessionId);
    return sessionId;
  }

  // Method to clear the sessionId from memory and sessionStorage
  public static clearSessionId(): void {
    this.sessionId = null;
    
    try {
      sessionStorage.removeItem(this.sessionKey);
    } catch (error) {
      console.warn('Failed to remove from sessionStorage:', error);
    }
  }

  // Method to get or create a sessionId
  public static getOrCreateSessionId(): string {
    let sessionId = this.getSessionId();
    if (!sessionId) {
      sessionId = this.generateSessionId();
    }
    return sessionId;
  }
}